<template>
    <div class="list page-content">
        <b-table id="panel-table" class="panel-list" responsive striped hover :items="panelsToDisplay" :fields="fields" sort-by="first_seen" :sort-desc="true" @row-clicked="onPanelClicked">
            <template v-slot:cell(country_code)="data">
                <a :href="'/s/country/'+data.value">
                    <country-flag :class="{ 'rotating': easterEgg }" :country='data.value' v-b-tooltip.hover :title='countryName(data.value)'/>
                </a>
            </template>
            <template v-slot:cell(bot_total)="data">
                <span v-if="data.value || data.value === 0">{{ data.value }}</span>
                <span v-else class="unknown">-</span>
            </template>
            <template v-slot:cell(top_country)="data">
                <country-flag v-if="data.value && data.value !== 'aa'" :class="{ 'rotating': easterEgg }" :country='data.value' v-b-tooltip.hover :title='countryName(data.value)'/>
                <span v-else class="unknown unknown--cn">-</span>
            </template>
            <template v-slot:cell(panel_version)="data">
                <a :href="'/s/panel_version/'+data.value">{{ data.value }}</a>
            </template>
            <template v-slot:cell(ip)="data">
                <a :href="'/s/ip/'+data.value">{{ data.value }}</a>
            </template>
            <template v-slot:cell(asn)="data">
                <a :href="'/s/asn/'+data.value">{{ data.value }}</a>
            </template>
            <template v-slot:cell(status)="data">
                <a :href="'/s/status/'+data.value">
                    <b-badge :variant="statusBadge(data.value)">{{ data.value }}</b-badge>
                </a>
            </template>
            <!-- <template v-slot:cell(panel_index)="data">
                <a :href="'#'">{{ data.value }}</a>
            </template> -->
        </b-table>
        <b-pagination
            v-if="this.numberOfPanels"
            align="center"
            v-model="currentPage"
            :total-rows="numberOfPanels"
            :per-page="perPage"
            aria-controls="panel-table"
        ></b-pagination>
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
    components: {
        CountryFlag
    },
    data() {
        return {
            panels: [],
            panelsToDisplay: [],
            lastData: {},
            isSearch: false,
            numberOfPanels: 0,
            perPage: 50,
            currentPage: 1,
            fields: [
                { key: 'first_seen', label: 'First seen', formatter: 'tsDate', class: 'd-none d-md-table-cell', sortable: true },
                { key: 'country_code', label: 'Country', class: 'd-none d-md-table-cell', sortable: true},
                { key: 'panel_index', label: 'C2 index', sortable: true },
                { key: 'bot_total', label: 'Victims', class: 'd-none d-lg-table-cell', formatter: 'victimsFormatter', sortable: true, sortDirection: "desc"},
                { key: 'top_country', label: 'Top victims', class: 'd-none d-lg-table-cell', formatter: 'topVictimsFormatter', sortable: true},
                { key: 'panel_version', label: 'Version', class: 'd-none d-md-table-cell', sortable: true, sortDirection: "desc" },
                { key: 'ip', label: 'IP', class: 'd-none d-lg-table-cell', sortable: true },
                { key: 'asn', label: 'AS', class: 'd-none d-lg-table-cell', sortable: true },
                { key: 'status', label: 'Status', sortable: true, sortDirection: "desc" },
            ],
            easterEgg: false
        }
    },
    mounted() {
        // Get page number in URL
        let pageNum = parseInt(this.$route.hash.slice(1))
        this.easterEgg = false
        if (pageNum === 1337) {
            this.easterEgg = true
        }
        else if (!isNaN(pageNum)) {
            this.currentPage = Math.max(pageNum, 0)
        }
        // Get and initialize panels
        this.init()
    },
    watch: {
        '$route.params'() {
            this.init()
        },
        'currentPage'() {
            history.pushState({}, null, this.$route.path + '#' + this.currentPage)
            this.updatePanels()
        }
    },
    methods: {
        init() {
            if (this.$route.params.type && this.$route.params.query) {
                this.isSearch = true

                // Search logic
                switch(this.$route.params.type) {
                    case 'asn':
                        this.$API.getASN(this.$route.params.query.toUpperCase())
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    case 'country':
                        this.$API.getCountryCode(this.$route.params.query.toUpperCase())
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    case 'ip':
                        this.$API.getIP(this.$route.params.query)
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    case 'panel_index':
                        this.$API.getPanelIndex(this.$route.params.query)
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    case 'FQDN':
                        this.$API.getDomain(this.$route.params.query)
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    case 'HTTPFQDN':
                        this.$API.getDomain(this.$route.params.query.replace(/^(http(s?):\/\/)/,"").replace("/",""))
                            .then(panels => this.initPanelsSearch(panels))
                        break
                    default:
                        this.$router.push('/').catch(() => {})
                }
            }
            else {
                this.isSearch = false

                this.$API.getCountField('_id').then(count => {
                    this.numberOfPanels = count
                    this.updatePanels()
                })
            }
        },
        initPanelsSearch(panels) {
            this.initPanels(panels)
            this.updatePanels()
        },
        initPanels(panels) {
            this.panels = panels
            if (this.isSearch) {
                this.numberOfPanels = panels.length
            }
            this.panels.map(panel => {
                panel.lastData = this.getLastData(panel)
                panel.bot_total = panel.lastData ? panel.lastData.bot_total : undefined
                let lastDataCountries = []
                if (panel.lastData && panel.lastData.country) {
                    Object.keys(panel.lastData.country).forEach(country => {
                        if (country !== 'aa') {
                            lastDataCountries.push(country)
                        }
                    })
                }
                panel.top_country = lastDataCountries.length ? lastDataCountries[0] : undefined
            })
        },
        getLastData(panel) {
            if (!Array.isArray(panel.data)) {
                return panel.data
            }
            let lastData = {}
            for (let i = panel.data.length-1; i >=0; i--) {
                if (panel.data[i].config !== undefined){
                    lastData = panel.data[i]
                    break
                }
            }
            return lastData
        },
        onPanelClicked(panel) {
            this.$router.push({ path: `/panel/${panel._id}` })
        },
        statusBadge(status) {
            return {
                "online": "success",
                "offline": "danger",
                "waiting": "secondary"
            }[status]
        },
        countryName(country) {
            return country in this.$const.countries
                ? this.$const.countries[country.toLowerCase()].name
                : ''
        },
        tsDate(value) {
            return this.$moment(value * 1000).format('YYYY-MM-DD')
        },
        victimsFormatter(value) {
            if (!Number.isInteger(value)){
              return undefined
            }
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            return value
        },
        topVictimsFormatter(value, key, item) {
            if (item.bot_total === 0) {
                return undefined
            }
            return value
        },
        updatePanels() {
            let skip = this.numberOfPanels - (this.currentPage * this.perPage)
            let limit = this.perPage
            if (skip < 0) {
                limit = limit + skip
                skip = 0
            }
            if (!this.isSearch) {
                this.$API.getLastData(skip, limit).then(panels => {
                    this.initPanels(panels)
                    this.panelsToDisplay = this.panels
                    // this.panelsToDisplay = panels
                })
            }
            else {
                this.panelsToDisplay = this.panels.slice(skip, skip + limit)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.unknown {
    color: #8f7d7d;

    &--cn {
        margin-left: 12px;
    }
}
</style>

<style lang="scss">
.panel-list {
    .b-table tr {
        cursor: pointer;
    }
}

.b-table  tr td:nth-child(3) a{
  word-wrap: anywhere;
}

.page-item {
    .page-link {
        background: #443A3A !important;
    }
    &.active .page-link {
        background: #302727 !important;
    }
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
</style>
